module.exports = __webpack_public_path__ + "static/media/emails-icon.933319d3.svg";